// WHY: a mailto: link is built by string concatenation, so header/recipient-delimiter characters
// (?, &, whitespace, %, comma, semicolon) must be excluded to block Cc/Bcc/subject/recipient injection.
const SAFE_EMAIL_PATTERN = /^[^\s?&%,;]+$/;
export function isSafeEmailValue(email) {
    return SAFE_EMAIL_PATTERN.test(email);
}
//# sourceMappingURL=is-safe-email-value.js.map